export default __webpack_public_path__ + "static/FS2S-InHub-187-28c6471de13683ea201806c68a8a1a31.jpg";